import * as _ from 'lodash';
import Validator from 'validatorjs';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import ContabilidadRules from '../../../support/rules/ine/ContabilidadRules';

const EntidadForm = (props) => {

  const [data, setData] = useState({});
  const [validation, setValidation] = useState({
    validator: new Validator({}, ContabilidadRules()),
    isValid: false,
  });

  const { isValid } = validation;
  const { data: editing } = props;
  const rules = ContabilidadRules(data);

  const handleOnChange = (event) => {
    const newData = {
        ...data,
        ...event,
    }

    setData(newData);
  }

  const validate = (data) => {
    let passes = false;
    const validator = new Validator(data, ContabilidadRules(data));

    if (!_.isEmpty(data)) {
      passes = validator.passes()
    }

    const newValidation = {
      validator: validator,
      isValid: passes
    };

    setValidation(newValidation);
  }

  useEffect(() => {
    validate(data);
  }, [data]);

  useEffect(() => {
    if (!!editing && !!editing.id) {
      setData({
        ...data,
        ...editing,
      });
    }
  }, [editing]);// eslint-disable-line react-hooks/exhaustive-deps

  const handleOnAdd = () => {
    props.onAdd(data);

    clear();
  }

  const handleOnClose = () => {
    props.onClose();
  }

  const clear = () => {
    setData({});
  };

  return (
    <>
      <h5 className="text-right">Entidad/Contabilidad</h5>

      <Row>
        <Col sm md={ 12 }>
          <FormControl
            type="text"
            label="ID contabilidad"
            name="IdContabilidad"
            placeholder=""
            help=""
            rules={ rules.IdContabilidad }
            value={ data.IdContabilidad }
            onChange={ handleOnChange }
          />
        </Col>
      </Row>

      <Row>
        <Col className="text-right pb-2">
          <Button
            variant="secondary"
            className="mr-2"
            onClick={ handleOnClose }
          >
            Cancelar
          </Button>
          <Button
            variant="secondary"
            disabled={ !isValid }
            onClick={ handleOnAdd }
          >
            Agregar ID contabilidad
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default EntidadForm;
